import Directory from "../directory/Directory";

function Home() {
  return (
    <div className="homeroute">
      <Directory />
    </div>
  );
}

export default Home;
